import { RegistrationType } from 'screens/LoginOrSignup/utils'
import OauthLanding from './OauthLanding'

export const FacebookLanding = () => <OauthLanding provider={RegistrationType.Facebook} />

export default FacebookLanding
